<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 v-if="open" class="modal-title">請選擇要列印的格式</h3>
        </div>
        <div v-if="open" class="modal-body send-modal-body" style="min-height:220px;" :class="{'section-loading': sendLoading}">
          <ul>
            <li><span style="color:red;font-weight: bold">本次列印之服務聯繫專函不包含「契約資料一覽表」，請選擇列印格式。</span></li>
            <li>如有疑問，請洽總公司業務部業務企劃科(02)27551399#{{ this.$store.state.serviceLine }}。</li>
          </ul>
          <div style="text-align:center;">
            <a @click="openSendallModal('4')"  class="btn btn-primary">親送專函</a>
            <a @click="openSendallModal('5')"  class="btn btn-primary">郵寄專函</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 專函 -->
    <send-all-modal 
      :open="sendallModalOpen"
      :ceapcnoList="ceapcnoList"
      :visit_noList="visit_noList"
      :sendtype="sendType"  
      @close="close()"
     />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {commonMixin} from '@/mixins/common'
import SendAllModal from "./SendAllModal"
import { getChangeNotice_csid } from '@/service'

export default {
  name: 'PrintAllModal',
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custs: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },  
  components: {
    SendAllModal
  },
  data() {
    return {
      sendLoading: false,
      sendTypeName: '',
      sendallModalOpen: false,
      sendType: 'send',
      sendCustData: {},
      tableData: [],
      tableDataBackup: [],
      tableData: [],
      ceapcnoList: [],
      visit_noList: [],
    }
  },
  watch: {
    open: "initPrintall"
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    openSendallModal(type) {  //打開 專函
      this.sendType = type
      this.panelOpen("sendallModalOpen");
      //this.$emit('close');
    },
    close(){
      this.panelClose('sendallModalOpen');
      //this.cust = [];
      this.ceapcnoList=[];
      this.visit_noList=[];
      this.$emit('close');
    },
    initPrintall () {  // 初始化
    if(this.open) {
        this.ceapcnoList=[];
        this.visit_noList=[];
        let uniqueCust = [...new Set(this.custs)]; //過濾掉重複ID的資料
        this.sendLoading = true
        getChangeNotice_csid(this.$store.state.userInfo.id,uniqueCust).then(result => {  // 取得客戶列表
          this.sendLoading = false
          if(result && result.header.status == '200' && result.body){
            let lists = result.body.notice_list || [];
            this.tableData = lists.map(item => {
              return {
                ceapcno: item.ceapcno || '', //客戶ID
                visit_no: item.visit_no || '',//拜訪編號，存失聯件用
              }
            })
            this.tableDataBackup = this.tableData.map(ele => {return ele;});
            this.tableData.map(data => {
                this.ceapcnoList.push(data.ceapcno)
                this.visit_noList.push(data.visit_no)
              });
            this.registerHanlink();  // for hard word
          }
        })
      }    
    }
  }
}
</script>
